// base is used in parent CLASS in index.js
const base = {
	indexName: 'prod_searchable_posts',
	suggestionsIndexName: 'prod_searchable_posts_query_suggestions',
	searchParam: 'query',
	siteTitle: 'UL Researech Institutes',
	selectors: {
		searchWrap: '.aside-layout__aside',
	},
	classes: {
		facet: 'algolia__facet'
	}
}

const facets = [
	{
		slug: 'post_type_label',
		container: '.algolia__facet--post-type',
		label: 'Content Type',
		attribute: 'post_type_label'
	},
	{
		slug: 'category',
		container: '.algolia__facet--category',
		attribute: 'taxonomies.category.name',
		label: 'Article Type'
	},
	{
		slug: 'event_type',
		container: '.algolia__facet--event-type',
		attribute: 'taxonomies.event_type.name',
		label: 'Event Type',
	},
	{
		slug: 'institutes_and_offices',
		container: '.algolia__facet--institutes-and-offices',
		attribute: 'taxonomies.institutes_and_offices.name',
		label: 'Institutes and Offices'
	},

]

const configure = {
	hitsPerPage: 9,
	maxValuesPerFacet: 20,
	snippetEllipsisText: '…',
	distinct: true,
	clickAnalytics: true,
	// enablePersonalization: true,
	attributesToSnippet: [
		'post_title:7',
		'post_content:15',
		'post_excerpt:15'
	],
};

export const searchBox = {
	autofocus: true,
	showReset: false,
	showSubmit: true,
	placeholder: 'Enter Keywords...',
	container: '.algolia__searchBox',
	cssClasses: {
		input: 'algolia__search-input',
		main: 'algolia__input--main',
		shadow: 'algolia__input--shadow',
		submit: 'algolia__search-submit',
		form: 'algolia__search',
	}
}

const hits = {
	escapeHTML: false,
	container: '.algolia__hits-wrap',
	imageSize: 'large',
	cssClasses: {
		emptyRoot: 'algolia__hits--empty',
		list: 'algolia__hits',
		item: 'algolia_hit',
		input: 'algolia__input',
		formWrap: 'algolia__form-wrap',
		form: 'algolia__form',
		root: '',
	}
}


const pagination = {
	container: '.algolia__pagination',
	padding: 2,
	showFirst: false,
	showLast: false,
	cssClasses: {
		root: 'pagination',
		list: 'pagination__items',
		item: 'pagination__item',
		link: 'pagination__link',
		firstPageItem: 'pagination__item--first',
		lastPageItem: 'pagination__item--last',
		selectedItem: [
			'pagination__link',
			'current',
		],
		nextItem: 'pagination__item--next',
		numbers: 'pagination__item--numbers',
		number: 'pagination__number',
		previousItem: 'pagination__item--previous',
		disabledItem: 'pagination__link--disabled',
	}
};

const clearRefinements = {
	container: '.algolia__clearRefinements',
	text: {
		label: 'Clear All'
	},
	cssClasses: {
		root: 'algolia__active',
		button: 'algolia__active-filter',
		item: 'algolia__active-filter',
		text: 'algolia__active-filter-text',
		list: 'algolia__active-filters',
	}
};

const currentRefinements = {
	container: '.algolia__currentRefinements',
	text: {
		label: 'Applied Filters',
	},
	showCount: true,
	cssClasses: {
		root: '',
		disabled: 'algolia__refinements-button--disabled',
		list: 'algolia__active-filters',
		activeLabel: 'algolia__active-label has-meta-variant',
		delete: 'algolia__active-filter-delete',
		item: 'algolia__active-filter',
		categoryLabel: 'algolia__active-filter-text',
		label: 'algolia__active-filter-label',
		facetLabel: 'algolia__facet-label',
	}
};

export const opts = {
	base,
	configure,
	currentRefinements,
	clearRefinements,
	hits,
	pagination,
	facets,
	searchBox
}

